import React from "react";
import {
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Input,
  Label,
  FormGroup,
  Spinner,
  Form
} from "reactstrap";
import { encryptIntoHash, decryptHash } from "../../../Utils";
import { connect } from "react-redux";
import firebase from "../../../config/firebase";

class changePassword extends React.Component {
  state = {
    modal: false,
    prevPassword: "",
    newPassword: "",
    confirmPassword: "",
    loading: false,
    filled: false
  };

  // Modal Toggler.
  toggle = () =>
    this.setState(({ modal }) => ({
      modal: !modal
    }));

  onChangeHandler = e => {
    const { prevPassword, newPassword, confirmPassword } = this.state;
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        if (prevPassword && newPassword && confirmPassword) {
          this.setState({ filled: true });
        } else this.setState({ filled: false });
      }
    );
  };

  updatePassHandler = async e => {
    e.preventDefault();
    const { prevPassword, newPassword, confirmPassword } = this.state;
    const user = firebase.auth().currentUser;
    const userRef = firebase
      .firestore()
      .collection("users")
      .doc(user.uid);
    try {
      const res = await userRef.get();
      if (prevPassword !== decryptHash(res.data().password)) {
        console.log({
          prev: prevPassword,
          match: decryptHash(res.data().password)
        });
        alert("Error: Previous password is incorrect");
        return;
      } else if (confirmPassword !== newPassword) {
        alert("Error: Confirm password doesn't match");
        return;
      } else {
        this.setState({
          prevPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        user
          .updatePassword(newPassword)
          .then(async () => {
            console.log("success");

            const res = await userRef.update({
              password: encryptIntoHash(newPassword)
            });
            this.setState({ modal: false });
            alert("Password updated Successfully");
          })
          .catch(function(error) {
            console.log(error);
            alert("Error: " + error.message);
          });
      }
    } catch (err) {
      console.log(err);
      alert("Error: ", err.message);
      return;
    }
  };

  render() {
    const { modal, filled, loading } = this.state;
    return (
      <>
        <Button color="danger" size="sm" onClick={this.toggle}>
          Change Password
        </Button>{" "}
        <Modal isOpen={modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Change Password</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="prevPass">Prev Password</Label>
                  <Input
                    type="password"
                    name="prevPassword"
                    id="prevPass"
                    placeholder="Previous password"
                    onChange={this.onChangeHandler}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="newPass">New Password</Label>
                  <Input
                    type="password"
                    name="newPassword"
                    id="newPass"
                    placeholder="New password"
                    onChange={this.onChangeHandler}
                  />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="confirmPass">Confirm Password</Label>
                  <Input
                    type="password"
                    name="confirmPassword"
                    id="confirmPass"
                    placeholder="confirm password"
                    onChange={this.onChangeHandler}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={this.updatePassHandler}
              size="sm"
              disabled={!filled}
            >
              {loading ? <Spinner animation="grow" size="sm" /> : "Update"}
            </Button>{" "}
            <Button color="secondary" onClick={this.toggle} size="sm">
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  console.log({ state: state.authReducer.user });
  return {
    user: state.authReducer.user
    // error: state.authReducer.error
  };
};

export default connect(mapStateToProps, null)(changePassword);
